module.exports = __webpack_public_path__ + "static/media/reference-slider-22.968614e4.jpg";